export default "__VITE_ASSET__BxRky7JI__"